window.addEventListener('load', function(){
  $("#hamburger").click(function() {
    $("#accessibleNav").slideToggle(500);
  });
  if ($('.header__nav-primary-link.Culture').next().find('li a').hasClass("header__nav-sec-link--active")) {
    if ($('.Culture').next().hasClass("show")) {
        $('.Culture').next().removeClass("show");
        $('.Culture').next().slideUp(300); 
        $('.Culture').removeClass('active-sub'); 
    } else {
        $('.Culture').parent().parent().find("li .site-nav--dropdown").removeClass("show");
        $('.Culture').parent().parent().find("li .site-nav--dropdown").slideUp(300);
        $('.Culture').next().toggleClass("show");
        $('.Culture').next().slideToggle(300);
        $('.Culture').addClass('active-sub'); 
    }
  }
  if ($('.header__nav-primary-link.Public.Bar').next().find('li a').hasClass("header__nav-sec-link--active")) {
    if ($('.Public.Bar').next().hasClass("show")) {
        $('.Public.Bar').next().removeClass("show");
        $('.Public.Bar').next().slideUp(300); 
        $('.Public.Bar').removeClass('active-sub'); 
    } else {
        $('.Public.Bar').parent().parent().find("li .site-nav--dropdown").removeClass("show");
        $('.Public.Bar').parent().parent().find("li .site-nav--dropdown").slideUp(300);
        $('.Public.Bar').next().toggleClass("show");
        $('.Public.Bar').next().slideToggle(300);
        $('.Public.Bar').addClass('active-sub'); 
    }
  }
  if ($('.header__nav-primary-link.Shop').next().find('li a').hasClass("header__nav-sec-link--active")) {
    if ($('.Shop').next().hasClass("show")) {
        $('.Shop').next().removeClass("show");
        $('.Shop').next().slideUp(300);
        $('.Shop').removeClass('active-sub'); 
    } else {
        $('.Shop').parent().parent().find("li .site-nav--dropdown").removeClass("show");
        $('.Shop').parent().parent().find("li .site-nav--dropdown").slideUp(300);
        $('.Shop').next().toggleClass("show");
        $('.Shop').next().slideToggle(300);
        $('.Shop').addClass('active-sub'); 
    }
  }
  if ($('.site-nav--dropdown').hasClass("show")) {
      $('#body-wrapper').addClass('top-margin');
      } else {
      $('#body-wrapper').removeClass('top-margin');
  }
    
  $(".header__nav-primary-link").on("click", function() {
  if ($(this).next().hasClass("show")) {
      $(this).next().removeClass("show");
      $(this).next().slideUp(300);
      $('#body-wrapper').removeClass('top-margin');
  } else {
      $(this).parent().parent().find("li .site-nav--dropdown").removeClass("show");
      $(this).parent().parent().find("li .site-nav--dropdown").slideUp(300);
      $(this).next().toggleClass("show");
      $(this).next().slideToggle(300);
      $('#body-wrapper').addClass('top-margin');
  }
  });
  
  $(".header__nav-primary-item:not(.site-nav--has-dropdown)").on("click", function() {
    $("#accessibleNav").slideToggle(500);
  });

  
$( ".header__nav-sec-link.Newsletter" ).click(function() {
$('.popup-wrap')
    .css("display", "flex")
    .hide()
    .fadeIn(500);
    $('body').css('overflow', 'hidden');
	
});
$( ".footer__menu-link.Newsletter" ).click(function() {
$('.popup-wrap')
    .css("display", "flex")
    .hide()
    .fadeIn(500);
    $('body').css('overflow', 'hidden');
	
});
$('.popup .btn-close').on("click",function(){
	$('.popup-wrap').fadeOut(500);
    $('body').removeAttr("style");
});
// Close modal on click away
var modal = document.getElementById('mc-subscribe');
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    document.body.style.overflow = "visible";
  }
}

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

  
});